import React, {forwardRef} from 'react';
import ListadoLeccionesSeccion from './ListadoLeccionesSeccion';

export const Item = forwardRef(({id, ...props}, ref) => {
    const {seccionInfo = {}, leccionInfo = {}, isLeccionItem = false} = props;
  return (
    <div {...props} ref={ref}>{id}. {isLeccionItem ? leccionInfo.nombre : seccionInfo.nombre} - {isLeccionItem ? leccionInfo.codigoLeccion : seccionInfo.codigoSeccion}</div>
  )
});